var _circle, _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#ECF9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8633 12.8633C12.8633 10.8677 14.481 9.24997 16.4766 9.24997C17.402 9.24997 18.2462 9.59787 18.8854 10.17C19.5247 9.59787 20.3688 9.24997 21.2943 9.24997C23.2898 9.24997 24.9076 10.8677 24.9076 12.8633C24.9076 13.2856 24.8351 13.691 24.702 14.0677H26.112C27.4424 14.0677 28.5208 15.1462 28.5208 16.4765C28.5208 17.8069 27.4424 18.8854 26.112 18.8854H20.0898V17.681C20.0898 17.0158 19.5506 16.4765 18.8854 16.4765C18.2202 16.4765 17.681 17.0158 17.681 17.681V18.8854H11.6589C10.3285 18.8854 9.25 17.8069 9.25 16.4765C9.25 15.1462 10.3285 14.0677 11.6589 14.0677H13.0689C12.9357 13.691 12.8633 13.2856 12.8633 12.8633ZM17.681 14.0677V12.8633C17.681 12.1981 17.1417 11.6588 16.4766 11.6588C15.8114 11.6588 15.2721 12.1981 15.2721 12.8633C15.2721 13.5284 15.8114 14.0677 16.4766 14.0677H17.681ZM21.2943 14.0677C21.9595 14.0677 22.4987 13.5284 22.4987 12.8633C22.4987 12.1981 21.9595 11.6588 21.2943 11.6588C20.6291 11.6588 20.0898 12.1981 20.0898 12.8633V14.0677H21.2943Z",
    fill: "#4FC0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.681 20.0898H10.4544V26.1119C10.4544 27.4423 11.5329 28.5208 12.8633 28.5208H17.681V20.0898Z",
    fill: "#4FC0CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0898 28.5208H24.9076C26.2379 28.5208 27.3164 27.4423 27.3164 26.1119V20.0898H20.0898V28.5208Z",
    fill: "#4FC0CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.7915,
    y: 7.70837,
    width: 16.9583,
    height: 6.35938,
    fill: "#ECF9FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3566 13.3354C19.3566 13.3354 19.3566 11.9546 19.3566 11.4854C19.3566 10.4637 20.2003 9.63542 21.2409 9.63542C22.2816 9.63542 23.1252 10.4637 23.1252 11.4854C23.1252 12.5071 22.2816 13.3354 21.2409 13.3354C20.6781 13.3354 19.3566 13.3354 19.3566 13.3354ZM19.3566 13.3354C19.3566 13.3354 19.3566 11.5436 19.3566 11.0229C19.3566 9.74576 18.3021 8.71042 17.0013 8.71042C15.7005 8.71042 14.646 9.74576 14.646 11.0229C14.646 12.3001 15.7005 13.3354 17.0013 13.3354C17.7718 13.3354 19.3566 13.3354 19.3566 13.3354Z",
    stroke: "#7ED957",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralGiftIcon);
export default __webpack_public_path__ + "static/media/referral-gift-icon.2546331e36527de63b699e24ba52ac6c.svg";
export { ForwardRef as ReactComponent };